import { useState, useEffect } from 'react';
import qs from 'qs';
import { useNavigate, useLocation } from 'react-router-dom';
import { Title, Grid, TextInput, Button, Group, Box, Text } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

import { useAppSelector } from '../../../store/hooks';
import { qsString } from '../../../utils/qsHelpers';

interface LogradouroSearchProps {
  page: number;
  pageSize: number;
}

export default function LogradouroSearch({ page, pageSize }: LogradouroSearchProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const loading = useAppSelector((state) => state.container.loading);
  const results = useAppSelector((state) => state.logradouros.results);
  const publicSettings = useAppSelector((state) => state.publicSettings.settings);

  const [searchValue, setSearchValue] = useState('');
  const [filterText, setFilterText] = useState('');
  const [filterExtent, setFilterExtent] = useState('');

  const syncFromUrl = () => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    setSearchValue(qsString(query.q));
    setFilterText(qsString(query.q));
    setFilterExtent(qsString(query.e));
  };

  useEffect(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (query.q || query.e) syncFromUrl();
  }, []);

  useEffect(() => { syncFromUrl(); }, [location.key]);

  const clickSearch = () => {
    const query = qs.stringify({ page: 1, pageSize, q: searchValue });
    setFilterText(searchValue);
    navigate('/logradouro?' + query);
  };

  const total = !results ? 0 : results.total;
  const menorRnum = ((page - 1) * pageSize) + 1;
  let maoirRnum = page * pageSize;
  if (total > 0) maoirRnum = maoirRnum < total ? maoirRnum : total;

  let filterMessage: string | null = null;
  if (filterText?.length > 0) filterMessage = `Filtrado por "${filterText}"`;
  else if (filterExtent?.length > 0) filterMessage = 'Filtrado espacialmente';

  return (
    <Box>
      <Title order={1}>Listar {publicSettings?.logradouroAbaName}</Title>

      <Grid gap="md" mt="md">
        <Grid.Col span={{ base: 12, md: 7 }} offset={{ base: 0, md: 2 }}>
          <TextInput
            disabled={loading}
            autoFocus
            maxLength={300}
            placeholder="Nome do Logradouro"
            leftSection={<IconSearch size={16} />}
            value={searchValue || ''}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') clickSearch(); }}
            rightSectionWidth={92}
            rightSection={
              <Button size="xs" onClick={clickSearch} leftSection={<IconSearch size={14} />}>
                Buscar
              </Button>
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 7 }} offset={{ base: 0, md: 2 }}>
          <Group justify="space-between">
            <Text fw={600}>{filterMessage}</Text>
            {total > 0 && !!menorRnum && (
              <Text size="sm" c="dimmed">
                Listando {menorRnum} - {maoirRnum} de {total} registros.
              </Text>
            )}
          </Group>
        </Grid.Col>
      </Grid>
    </Box>
  );
}
